<template>
  <div class="min-vh-100 d-flex flex-row align-items-center sign-bg">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol :md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm @submit.prevent="sign">
                  <h1>登入</h1>
                  <p class="text-medium-emphasis m-0">登入您的帳戶</p>
                  <p class="text-medium-emphasis" style="font-size: 12px">Log in to your account</p>
                  <CInputGroup class="mb-3">
                    <CInputGroupText>
                      <CIcon icon="cil-user" />
                    </CInputGroupText>
                    <CFormInput
                      placeholder="使用者名稱 Username"
                      autocomplete="username"
                      v-model="username"
                    />
                  </CInputGroup>
                  <CInputGroup class="mb-4">
                    <CInputGroupText>
                      <CIcon icon="cil-lock-locked" />
                    </CInputGroupText>
                    <CFormInput
                      type="password"
                      placeholder="使用者密碼 Password"
                      autocomplete="current-password"
                      v-model="password"
                    />
                  </CInputGroup>
                  <CRow>
                    <CCol :xs="12" class="d-flex justify-content-end">
                      <CButton
                        color="primary"
                        class="px-4 text-white"
                        type="submit"
                      >
                        {{"登入 Login"}}
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard class="text-white right-bg py-5" style="width: 44%">
              <CCardBody
                class="d-flex align-items-center flex-column justify-content-center col-12"
              >
                <img
                  class="mb-4 col-6"
                  src="@/assets/images/logo-black.svg"
                  alt=""
                />
                <p class="m-0">ESG問卷填答系統</p>
                <p style="font-size:12px">ESG Questionnaire Response System</p>
                <!-- <span
                  >還沒有帳號嗎？請<a href="/pretest">點選此處</a
                  >跟我們聯絡。</span
                > -->
                <span>無法登入嗎？請聯繫 info@jygesg.com</span>
                <span style="font-size: 12px;">Having trouble logging in?</span>
                <span style="font-size: 12px;">Please contact info@jygesg.com</span>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <MsgBox
      :show="showMsgBox"
      :errorMsg="errorMsg"
      @close="showMsgBox = false"
    />
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import useInfo from '@/composables/useInfo'
import MsgBox from '@/components/MsgBox.vue'
import router from '@/router'

export default {
  name: 'Login',
  components: {
    MsgBox,
  },
  setup() {
    const { signIn } = useInfo()
    const username = ref('')
    const password = ref('')
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const sign = async () => {
      const res = await signIn({
        username: username.value,
        password: password.value,
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
      } else {
        router.push('/questionnaire')
      }
    }
    return { username, password, sign, showMsgBox, errorMsg }
  },
}
</script>
<style lang="scss" scoped>
.sign-bg {
  background-image: url('~@/assets/images/sign.png');
  background-repeat: no-repeat;
  background-size: cover;
}
.right-bg {
  background: #fbfbfb;
  p {
    color: #4d4d4d;
    font-size: 28px;
  }
  span {
    color: #4d4d4d;
    font-size: 14px;
  }
}
</style>
